module.exports = __webpack_public_path__ + "static/media/hands-front.9eca61d1.png";